module.exports = __webpack_public_path__ + "static/media/gitLab-icon.b0bd29d5.png";